import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class PromotionalCode {
  code = ""
}

export const PROMOTIONAL_CODE_DESER: SchemaDeSer<PromotionalCode> =
  new SchemaDeSerBuilder(PromotionalCode).ofString("code").toDeSer()
